import React from 'react';

import Router from 'next/router';
import Text from 'components/core/Text';
import { Wrapper, BackgroundStyled, Content, Buttons, ButtonCancel, ButtonDelete } from './styles';

const Index = ({ hideModal, modalData }) => {
  const title = modalData.title || 'LEAVING THIS PAGE WILL DISCARD ALL ENTERED DATA';
  const description = modalData.description || 'Do you want to leave the page or keep editing?';
  const stayLabel = modalData.stayLabel || 'KEEP EDITING';
  const onLeave = modalData.onLeave || (() => Router.push(modalData.pathname));

  return (
    <>
      <BackgroundStyled onClick={hideModal} />
      <Wrapper>
        <Content>
          <Text variant="sectionHeader" tag="div" align="left" transform="none">
            {title}
          </Text>
          <Text align="left" mt={5}>
            {description}
          </Text>
          <Buttons>
            <ButtonCancel type="button" onClick={hideModal}>
              <Text tag="span" weight="bold">
                {stayLabel}
              </Text>
            </ButtonCancel>
            <ButtonDelete
              type="button"
              onClick={() => {
                hideModal();
                onLeave();
              }}
            >
              <Text tag="span" weight="bold">
                LEAVE
              </Text>
            </ButtonDelete>
          </Buttons>
        </Content>
      </Wrapper>
    </>
  );
};

export default Index;
